
const SectionTitle = ({ title }) => {
  return (
    <div className='row ps-0 my-5'>
        <h2 className='section-title blue'>{title}</h2>
    </div>
  )
}

export default SectionTitle
